<template>
  <div>
    <header-menu></header-menu>
    <router-view></router-view>
  </div>
</template>

<script>
import HeaderMenu from './components/Headermenu'

export default {
  data () {
    return {
    }
  },
  components: {
    HeaderMenu
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/panel/Home.vue